import React from 'react';

import styled from 'styled-components';

import theme from './theme';
import { IAccountLayout } from './types';

const Container = styled.div<IAccountLayout>`
  position: relative;
  min-height: 100%;
  margin: 0 auto;
  width: 100%;
  padding: ${({ mobileContainerPadding }) =>
    mobileContainerPadding ? mobileContainerPadding : '1.25rem 5% 6.25rem'};
  ${Styles.desktop`
    max-width: ${(props: IAccountLayout) => (props.fullWidth ? '100%' : '485px')};
    padding: ${({ header }: IAccountLayout) => header && '150px 0 100px 0'};
  `}
`;

const HeadingContainer = styled.div`
  margin: 2.5rem 0 1.25rem;
`;

const Header = styled.h1`
  text-align: center;
  font-family: ${Styles.fontFamily.base};
  text-transform: ${Styles.textTransform.headlines};
  margin: 0;
  line-height: ${theme.headerLineHeight};
`;

const LayoutRoot: React.FC<IAccountLayout> = ({
  children,
  header,
  subHeader = '',
  fullWidth = false,
  mobileContainerPadding,
}) => (
  <Container fullWidth={fullWidth} mobileContainerPadding={mobileContainerPadding} header={header}>
    {header && (
      <HeadingContainer>
        <Header>{header}</Header>
        {subHeader}
      </HeadingContainer>
    )}
    {children}
  </Container>
);

type Layout = typeof LayoutRoot & { Header: typeof Header };
const Layout = LayoutRoot as Layout;
Layout.Header = Header;

export default Layout;
